import { LoadGuideItem } from 'domain/usecases/surgical-order-guides/load-guide-item'
import { SurgicalOrderGuidesRepository } from 'repository/repositories/surgical-order-guides/surgical-order-guides-repository'

export class RemoteLoadGuideItem implements LoadGuideItem {
  constructor(
    private readonly surgicalOrderGuidesRepository: SurgicalOrderGuidesRepository
  ) {}
  load(
    health_insurance_procedure_id: number,
    health_insurance_code: number
  ): Promise<LoadGuideItem.Model> {
    return this.surgicalOrderGuidesRepository.loadGuideItem(
      health_insurance_procedure_id,
      health_insurance_code
    )
  }
}
